import { Fragment, memo, useCallback } from 'react';

import { Form } from '@wearehelpful/ui-kit';
import { useDate } from '@wearehelpful/ui-localization';
import { BDTO } from '@helpful/network';

interface ScheduleDatesProps {
  max?: string;
  days?: BDTO.GetTherapistScheduleDay[];
}

export const ScheduleDate = memo<ScheduleDatesProps>((props) => {
  const { now, format, isBefore, isAfter } = useDate();

  const min = now({ format: 'iso' }) as string;

  const { days = [], max = now({ format: 'iso' }) as string } = props;

  const highlightedDates = useCallback(
    (date: string) => {
      if (isBefore({ first: date, last: min })) {
        return false;
      }
      if (isAfter({ first: max, last: date })) {
        return false;
      }
      const current = format({
        value: date,
        format: 'l',
      });
      const highlighted = !days.find(({ date }) => {
        return format({ value: date, format: 'l' }) === current;
      })?.busy;
      return highlighted;
    },
    [format, days, isBefore, isAfter, max, min]
  );

  return (
    <Fragment>
      <Form.Date
        highlightedDates={highlightedDates}
        max={max}
        min={min}
        name="date"
      />
    </Fragment>
  );
});
